<template>
  <b-modal
    id="banks-dialog"
    title="تحديث الشركات المتعاقدة"
    hide-footer
    @hide="resetSelection"
    @show="fetchBanks"
  >
    <b-form-group label="بحث عن بنك">
      <b-form-input v-model="searchQuery" placeholder="ابحث عن بنك..." />
    </b-form-group>
    <b-form-group label="اختر البنوك">
      <b-list-group>
        <b-list-group-item
          v-for="bank in filteredBanks"
          :key="bank.value"
          class="d-flex justify-content-between align-items-center"
        >
          <span>{{ bank.text }}</span>
          <b-form-checkbox
            v-model="selectedBanks"
            :value="bank.value"
            @change="onBankSelectionChange"
          />
        </b-list-group-item>
      </b-list-group>
    </b-form-group>
    <b-row class="mt-3">
      <b-col>
        <b-button variant="info" block @click="updateBanks">تحديث</b-button>
      </b-col>
      <b-col>
        <b-button
          variant="outline-info"
          block
          @click="$bvModal.hide('banks-dialog')"
          >إلغاء</b-button
        >
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { successAlert, errorAlert } from "@/utils/helper";
import { $http } from "@/plugins/axios";

export default {
  props: { company: Object },
  data() {
    return {
      banks: [],
      selectedBanks: [],
      searchQuery: "",
    };
  },
  computed: {
    filteredBanks() {
      if (!this.searchQuery) return this.banks;
      return this.banks.filter((bank) =>
        bank.text.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  watch: {
    company: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.banks) {
          this.selectedBanks = newVal.banks.map((bank) => bank.id);
        }
      },
    },
  },
  methods: {
    fetchBanks() {
      $http
        .get("company-admin/banks")
        .then(({ payload }) => {
          this.banks = payload.map((bank) => ({
            text: bank.name,
            value: bank.id,
          }));
          if (this.company && this.company.banks) {
            this.selectedBanks = this.company.banks.map((bank) => bank.id);
          }
        })
        .catch(() => errorAlert("Failed to fetch banks."));
    },
    updateBanks() {
      // Only send checked bank IDs that exist in the banks list
      const validBankIds = Array.from(new Set(this.selectedBanks)).filter(
        (id) => this.banks.some((bank) => bank.value === id)
      );
      $http
        .post("company-admin/company-banks", {
          bank_ids: validBankIds,
          company_id: this.company.id,
        })
        .then(() => {
          successAlert("تم تحديث الشركات المتعاقدة بنجاح");
          this.$bvModal.hide("banks-dialog");
        })
        .catch(() => errorAlert("حدثت مشكلة أثناء تحديث الشركات المتعاقدة"));
    },
    resetSelection() {
      this.selectedBanks = [];
      this.searchQuery = "";
    },
    onBankSelectionChange() {
      // Remove duplicates immediately after any change
      this.selectedBanks = Array.from(new Set(this.selectedBanks));
    },
  },
};
</script>
